import * as yup from 'yup';

export const pickupLocationSchema = yup.object({
  name: yup.string().required('Name is required'),
  addressLine1: yup.string().required('Address line 1 is required'),
  addressLine2: yup.string().optional().nullable(),
  city: yup.string().optional().nullable(),
  state: yup.string().optional().nullable(),
  country: yup.string().optional().nullable(),
  countryOther: yup
    .string()
    .optional()
    .nullable()
    .when('country', {
      is: 'Other',
      then: (schema) => schema.required('Please specify the country'),
    }),
  stateOther: yup
    .string()
    .optional()
    .nullable()
    .when('state', {
      is: 'Other',
      then: (schema) => schema.required('Please specify the state'),
    }),
  zipCode: yup.string().optional().nullable(),
  phoneNumber: yup.string().optional().nullable(),
});

export type PickupLocationFormData = {
  name: string;
  addressLine1: string;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  countryOther?: string | null;
  stateOther?: string | null;
  zipCode?: string | null;
  phoneNumber?: string | null;
};
